import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'
import { getLastStepTypeSelector } from '../../../selectors/dialog'

export function useLastStepType(dialogId: string) {
  return useSelector<RootState, string | undefined>(getLastStepTypeSelector(dialogId))
}
